module.exports = __webpack_public_path__ + "static/logo-special-b5fbf17f6541c7e82c9afd9c541172e7.png";